import { actionTypes } from '@/core/constants'
import api from '@/core/apiclient'

export default {
	async [actionTypes.ITEM_ATA.REALINHAMENTO.HISTORICO.BUSCAR_HISTORICOS]({ state }, idItemAta) {
		const { paginacao } = state
		const { data } = await api.realinhamento.buscarHistoricoRealinhamento(idItemAta, paginacao)
		return data
	},
}
